import React, { useEffect, useState, useContext } from 'react'
import { components, constants, useServices } from 'cng-web-lib'
import pathMap from '../../../paths/pathMap'
import ResponseLog from './view/ResponseLog'
import { Box, Grid } from '@material-ui/core'
import AceHighwayShipmentApiUrls from 'src/apiUrls/AceHighwayShipmentApiUrls'
import ACEHighwayManifestTranslationText from './../contexts/ACEHighwayManifestTranslationText'

const { button: { CngButton } } = components
const { filter: { EQUAL } } = constants

function ViewLogsHistory(props) {
  
  const { history, manifestId, onChangeStep, onSubmitManifest, step } = props
  const { fetchRecords } = useServices()
  const aceHighwayManifestTranslationText = ACEHighwayManifestTranslationText()    


  const [shipmentEmpty, setShipmentEmpty] = useState(true);

  useEffect(() => {
    Promise.all([
      fetchRecords.execute(
        AceHighwayShipmentApiUrls.GET,
        { filters: [{ field: 'headerId', operator: EQUAL, value: manifestId }] },
        (res) => res.content
      )
    ]).then(([shipment]) => {
      setShipmentEmpty(shipment && shipment.length > 0 ? false : true);
    })
  }, []);

  return (
    <>
      <ResponseLog manifestId={manifestId} />
      <Box marginTop={2}>
        <Grid container justify='space-between' spacing={3}>
          <Grid item xs={12} md='auto'>
            <CngButton
              color='secondary'
              onClick={() =>
                history.push(pathMap.ACE_HIGHWAY_MANIFEST_LIST_VIEW)
              }
              size='medium'
            >
              {aceHighwayManifestTranslationText.discardButton}
            </CngButton>
          </Grid>
          <Grid item xs={12} md='auto'>
            <Grid container spacing={2}>
              <Grid item xs='auto'>
                <CngButton color='secondary' onClick={() => onChangeStep(step - 1)} size='medium'>
                  {aceHighwayManifestTranslationText.backButton}
                </CngButton>
              </Grid>
              <Grid item xs='auto'>
                <CngButton
                  color='primary'
                  onClick={() => shipmentEmpty ? onChangeStep(step - 3) : onChangeStep(step - 2)}
                  size='medium'>
                  {aceHighwayManifestTranslationText.goToSubmit}
                </CngButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default ViewLogsHistory
